export default __webpack_public_path__ + "static/Image22@2x-9654826fcf4f7c28d2567f2427fae330.png";